module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/267.1cfe97ec.png";